import { useEffect, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useSelectFormStore, useForm, useDoctorsStore } from "../../../hooks";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  SuccessMessage,
  MainButton,
} from "../../ui";
import { useFormMessages } from "../../hooks";

const formData = {
  document: "",
  documentTypeId: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  countryPhoneId: "",
  country: "",
  department: "",
  city: "",
  address: "",
  genderId: "",
  specialtyId: "",
  medicalRegistry: "",
};

// const formData = {
//   document: "1234567891",
//   documentTypeId: "7f7d9793-8fc8-426b-a432-6b068a5c4a8f",
//   firstName: "test",
//   lastName: "test",
//   email: "doctortest@gmail.com",
//   phoneNumber: "3000000000",
//   countryPhoneId: "7a9e1fbd-8f68-4c54-8c0c-63c9d340a11c",
//   country: "Colombianito",
//   department: "Cundi",
//   city: "FacaYork",
//   address: "direccion",
//   genderId: "4b8c0d68-a291-48ce-a901-f7ae12e7d123",
//   specialtyId: "40cc6138-cdda-4e5a-8222-5a8b7098be36",
//   medicalRegistry: "123456789",
// };

const formValidations = {
  document: [
    (value) => value.length > 7,
    "El documento debe ser mayor a 7 caracteres",
  ],
  documentTypeId: [
    (value) => value.length > 0,
    "Selecciona un tipo de documento",
  ],
  firstName: [(value) => value.length > 0, "Los nombres no pueden ser vacios"],
  lastName: [(value) => value.length > 0, "Los apellidos no pueden ser vacios"],
  email: [(value) => value.includes("@"), "El email debe contener una @"],
  phoneNumber: [
    (value) => value.length > 9,
    "El numero de celular debe contener más de 9 digitos",
  ],
  countryPhoneId: [
    (value) => value.length > 0,
    "Selecciona un pais del celular",
  ],
  country: [(value) => value.length > 0, "El país no puede ser vacio"],
  department: [
    (value) => value.length > 0,
    "El departamento no puede ser vacio",
  ],
  city: [(value) => value.length > 0, "La ciudad no puede ser vacia"],
  address: [(value) => value.length > 0, "La dirección no puede ser vacia"],
  genderId: [(value) => value.length > 0, "Selecciona un género"],
  specialtyId: [(value) => value.length > 0, "Selecciona una especialidad"],
  medicalRegistry: [
    (value) => value.length > 0,
    "El registro médico no puede ser vacio",
  ],
};

export const AddDoctorCard = () => {
  // Datos del hook ----------------------------------------//
  const {
    //props
    isLoading,
    message,

    //methods
    startRegisterDoctor,
  } = useDoctorsStore();

  const {
    isLoading: isLoadingForm,
    documentTypes,
    countryPhones,
    genders,
    headquarters,
    specialties,
  } = useSelectFormStore([
    "documentTypes",
    "countryPhones",
    "genders",
    "headquarters",
    "specialties",
  ]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [headquartersForm, setHeadquartersForm] = useState([]);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
    onResetForm,
  });

  const {
    document,
    documentTypeId,
    firstName,
    lastName,
    email,
    phoneNumber,
    countryPhoneId,
    country,
    department,
    city,
    address,
    genderId,
    specialtyId,
    medicalRegistry,
  } = formState;

  const {
    documentValid,
    documentTypeIdValid,
    firstNameValid,
    lastNameValid,
    emailValid,
    phoneNumberValid,
    countryPhoneIdValid,
    countryValid,
    departmentValid,
    cityValid,
    addressValid,
    genderIdValid,
    specialtyIdValid,
    medicalRegistryValid,
  } = formValidation;

  // Funciones ---------------------------------------------//
  const handleChange = (index, value) => {
    setHeadquartersForm((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              headquarterId: value,
              headquarterIdValid: value ? null : "Seleccione una IPS",
            }
          : item
      )
    );
  };

  const handleAddField = () => {
    setHeadquartersForm((prev) => {
      // Verifica si el último campo tiene un `headquarterId` seleccionado
      const lastField = prev[prev.length - 1];

      // Si el último campo no tiene un `headquarterId`, muestra el error
      if (!lastField.headquarterId) {
        return prev.map((item, index) =>
          index === prev.length - 1 ? { ...item, isError: true } : item
        );
      }

      // Si tiene un `headquarterId`, marca el último campo como `disabled`
      const updatedList = prev.map((item, index) =>
        index === prev.length - 1 ? { ...item, disabled: true } : item
      );

      // Calcula las headquarters disponibles para el nuevo campo
      const availableHeadquarters = lastField.availableHeadquarters.filter(
        (item) => item.id !== lastField.headquarterId
      );

      if (availableHeadquarters.length === 0) return prev;

      // Añade un nuevo campo vacío con las IPS actualizadas
      return [
        ...updatedList,
        {
          headquarterId: "",
          headquarterIdValid: "Seleccione una Sede - ips",
          isError: false,
          availableHeadquarters,
          disabled: false,
        },
      ];
    });
  };

  const handleRemoveField = () => {
    setHeadquartersForm((prev) => {
      if (prev.length > 1) {
        // Crea una nueva lista eliminando el último elemento
        const updatedList = prev.slice(0, -1);
        // Asegúrate de que el último elemento de la lista actualizada tenga disabled: false
        updatedList[updatedList.length - 1] = {
          ...updatedList[updatedList.length - 1],
          disabled: false,
        };
        return updatedList;
      }
      return prev; // Si solo queda uno, no hace nada
    });
  };

  const onRegister = (event) => {
    event.preventDefault();
    setValidateForm(true);

    setHeadquartersForm((prev) => {
      // Verifica si el último campo tiene un `headquarterId` seleccionado
      const lastField = prev[prev.length - 1];

      // Si el último campo no tiene un `headquarterId`, muestra el error
      if (!lastField.headquarterId) {
        return prev.map((item, index) =>
          index === prev.length - 1 ? { ...item, isError: true } : item
        );
      }
      return prev;
    });

    // Extraer solo los `headquarterId` de la lista
    const selectedHeadquartersId = headquartersForm.map(
      (item) => item.headquarterId
    );

    if (
      isFormValid &&
      headquartersForm[headquartersForm.length - 1].headquarterId
    ) {
      setFormSubmitted(true);
      startRegisterDoctor(formState, selectedHeadquartersId);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (headquarters.length > 0) {
      setHeadquartersForm([
        {
          headquarterId: "",
          headquarterIdValid: "Seleccione una Sede - ips",
          isError: false,
          availableHeadquarters: headquarters,
          disabled: false,
        },
      ]);
    }
  }, [headquarters]);

  useEffect(() => {
    if (showSuccessMessage) {
      setHeadquartersForm([
        {
          headquarterId: "",
          headquarterIdValid: "Seleccione una Sede - ips",
          isError: false,
          availableHeadquarters: headquarters,
          disabled: false,
        },
      ]);
    }
  }, [showSuccessMessage]);

  return (
    <div className="card border-0 p-4 rounded shadow">
      <form onSubmit={onRegister}>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-6">
              <InputForm
                label={"Documento"}
                type={"text"}
                placeholder={"Documento"}
                validation={documentValid}
                submit={validateForm}
                name={"document"}
                value={document}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"Tipo de documento"}
                options={documentTypes}
                labelKey={"description"}
                validation={documentTypeIdValid}
                submit={validateForm}
                name={"documentTypeId"}
                value={documentTypeId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Nombres"}
                type={"text"}
                placeholder={"Nombres"}
                validation={firstNameValid}
                submit={validateForm}
                name={"firstName"}
                value={firstName}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Apellidos"}
                type={"text"}
                placeholder={"Apellidos"}
                validation={lastNameValid}
                submit={validateForm}
                name={"lastName"}
                value={lastName}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Email"}
                type={"text"}
                placeholder={"Email"}
                validation={emailValid}
                submit={validateForm}
                name={"email"}
                value={email}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"No. celular"}
                type={"text"}
                placeholder={"No. celular"}
                validation={phoneNumberValid}
                submit={validateForm}
                name={"phoneNumber"}
                value={phoneNumber}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"País del celular"}
                options={countryPhones}
                labelKey={"name"}
                validation={countryPhoneIdValid}
                submit={validateForm}
                name={"countryPhoneId"}
                value={countryPhoneId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <hr />
            </div>
            <h6 className="">Dirección</h6>
            <div className="col-md-6">
              <InputForm
                label={"Pais"}
                type={"text"}
                placeholder={"Pais"}
                validation={countryValid}
                submit={validateForm}
                name={"country"}
                value={country}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Departamento"}
                type={"text"}
                placeholder={"Departamento"}
                validation={departmentValid}
                submit={validateForm}
                name={"department"}
                value={department}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Ciudad"}
                type={"text"}
                placeholder={"Ciudad"}
                validation={cityValid}
                submit={validateForm}
                name={"city"}
                value={city}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Dirección"}
                type={"text"}
                placeholder={"Dirección"}
                validation={addressValid}
                submit={validateForm}
                name={"address"}
                value={address}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <hr />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"Genero"}
                options={genders}
                labelKey={"name"}
                validation={genderIdValid}
                submit={validateForm}
                name={"genderId"}
                value={genderId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <SelectForm
                label={"Especialidad"}
                options={specialties}
                labelKey={"name"}
                validation={specialtyIdValid}
                submit={validateForm}
                name={"specialtyId"}
                value={specialtyId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-6">
              <InputForm
                label={"Registro médico"}
                type={"text"}
                placeholder={"Registro médico"}
                validation={medicalRegistryValid}
                submit={validateForm}
                name={"medicalRegistry"}
                value={medicalRegistry}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <hr />
            </div>
          </>

          {/* Formulario dinamico */}
          <>
            <h6 className="">Asignar sede - ips</h6>
            {headquartersForm.map((item, index) => (
              <div className="col-md-12" key={index}>
                <SelectForm
                  label={`${index + 1}. Sede - ips`}
                  options={item.availableHeadquarters}
                  labelKey={"name"}
                  validation={item.headquarterIdValid}
                  submit={item.isError}
                  name={`headquarterId-${index}`}
                  value={item.headquarterId}
                  onInputChange={(e) => handleChange(index, e.target.value)}
                  disabled={item.disabled}
                />
              </div>
            ))}
            <div className="col-md-6 d-flex align-items-center">
              <button
                type="button"
                className="btn btn-icon btn-soft-blue"
                onClick={() => handleAddField()}
                disabled={headquartersForm.length >= headquarters.length}
              >
                <FaPlus className="icons" />
              </button>
              <button
                type="button"
                className="btn btn-icon btn-soft-blue ms-2"
                onClick={() => handleRemoveField()}
                disabled={headquartersForm.length <= 1}
              >
                <FaMinus className="icons" />
              </button>
            </div>
          </>

          {/* Mensajes */}
          <>
            {(isLoading || isLoadingForm) && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
            {showSuccessMessage && (
              <div className="col-md-12">
                <SuccessMessage>{messageText}</SuccessMessage>
              </div>
            )}
          </>

          <div className="col-md-12">
            <hr />
          </div>

          {/* Submit */}
          <div className="col-md-12 d-flex justify-content-end">
            <MainButton type={"submit"} disabled={isLoading || isLoadingForm}>
              Agregar doctor
            </MainButton>
          </div>
        </div>
      </form>
    </div>
  );
};
